<template>
  <div class="pt-5 pb-5">
<!--    <div class="flex align-center mt-0 black-text">
      <h4 class="mt-0 mb-0 mr-5">Current greeting:</h4>
      <p>{{ name }}</p>
    </div>-->
    <h4 class="black-text mb-5 mt-5">Current greeting</h4>
    <div class="flex align-center">
      <el-button
        class="mr-5"
        type="primary"
        circle
        v-loading="playPending"
        :icon="isPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
        :disabled="playPending"
        @click="isPlaying ? pause() : play()"
      />
      <el-tooltip placement="top" content="Download Greeting">
        <el-button
          v-loading="downloadPending"
          :disabled="downloadPending"
          circle
          icon="el-icon-download"
          @click="download"
        />
      </el-tooltip>

      <div class="ml-80">
        <el-tooltip placement="top" content="Remove Greeting">
          <el-button
            v-loading="removeProcessing"
            :disabled="removeProcessing"
            type="danger"
            circle
            icon="el-icon-delete"
            style="background-color: #ef5350"
            @click="remove"
          />
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";

export default {
  name: "VmCurrentGreeting",

  props: {
    name: { required: true },
    record: { required: true },
    isPlaying: { required: true },
    removeProcessing: { required: true },
  },

  data() {
    return {
      blob: null,
      downloadPending: false,
      playPending: false,
    };
  },

  watch: {
    record() {
      this.blob = null;
    },
  },

  methods: {
    async fetchFile() {
      if (this.blob || !this.record) {
        return;
      }

      try {
        const res = await feathersClient
          .service("voicemail-messages")
          .get(this.record.id);

        if (!res || !res.recording) {
          this.$notify({
            title: "Not Found",
            message: "File Not Found.",
            type: "warning",
          });
          return;
        }

        this.blob = res.recording;
      } catch (err) {
        console.log({ err });
      }
    },

    async play() {
      this.playPending = true;
      await this.fetchFile();
      this.playPending = false;

      if (this.blob) {
        this.$emit("play", { type: "greeting", blob: this.blob });
      }
    },

    pause() {
      this.$emit("pause");
    },

    async download() {
      this.downloadPending = true;
      await this.fetchFile();

      if (this.blob) {
        const link = document.createElement("a");
        link.href = this.blob;
        link.download = this.name.split(".")[0];
        link.click();
      }

      this.downloadPending = false;
    },

    remove() {
      this.$confirm("Remove greeting?", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          this.$emit("remove", this.record.id);
        })
        .catch(() => true);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  margin-left: 0;
}
</style>
